export default {
  Hudl: 1,
  Team: 2,
  User: 3,
};
